import React from 'react';
import { Outlet } from 'react-router-dom';
import { WorkspaceProvider } from 'contexts/WorkspaceContext';
import { HoaPermissionsProvider } from 'contexts/PermissionsContext';

export default function RootProviders() {
  return (
    <WorkspaceProvider>
      <HoaPermissionsProvider>
        <Outlet />
      </HoaPermissionsProvider>
    </WorkspaceProvider>
  );
}
